const getOrCreateTooltip = chart => {
	let tooltipElement = chart.canvas.parentNode.querySelector('div');

	if (!tooltipElement) {
		tooltipElement = document.createElement('div');
		tooltipElement.classList.add('chart-tooltip');

		const table = document.createElement('table');

		tooltipElement.append(table);
		chart.canvas.parentNode.append(tooltipElement);
	}

	return tooltipElement;
};

const externalTooltipHandler = context => {
	/* Tooltip element */
	const { chart, tooltip } = context;
	const tooltipElement = getOrCreateTooltip(chart);

	/* Hide if no tooltip */
	if (tooltip.opacity === 0) {
		tooltipElement.style.opacity = 0;
		return;
	}

	/* Set Text */
	if (tooltip.body) {
		const secondDimensionLabel = tooltip.dataPoints[0].dataset.label;
		const titleLines = (secondDimensionLabel && secondDimensionLabel !== '') ? [secondDimensionLabel] : (tooltip.title || []);
		const bodyLines = tooltip.body.map(b => b.lines);

		const tableHead = document.createElement('thead');
		for (const title of titleLines) {
			const tr = document.createElement('tr');
			const th = document.createElement('th');
			const text = document.createTextNode(title.replaceAll(' , ', ' '));

			th.append(text);
			tr.append(th);
			tableHead.append(tr);
		}

		const tableBody = document.createElement('tbody');

		/* eslint-disable-next-line no-unused-vars */
		for (const [_i, body] of bodyLines.entries()) {
			const tr = document.createElement('tr');
			const td = document.createElement('td');
			const text = document.createTextNode(body);

			td.append(text);
			tr.append(td);
			tableBody.append(tr);
		}

		const tableRoot = tooltipElement.querySelector('table');

		/* Remove old children */
		while (tableRoot.firstChild) {
			tableRoot.firstChild.remove();
		}

		/* Add new children */
		tableRoot.append(tableHead);
		tableRoot.append(tableBody);
	}

	const { offsetLeft: positionX, offsetTop: positionY } = chart.canvas;

	/* Display, position, and set styles for font */
	tooltipElement.style.opacity = 1;
	tooltipElement.style.left = positionX + tooltip.caretX + 'px';
	tooltipElement.style.top = positionY + tooltip.caretY + 'px';
};

export default externalTooltipHandler;
